module.exports = __webpack_public_path__ + "img/logosmall.c81639fa.svg";